module.exports = "<div *ngIf=\"guide\">\n  <h1>{{ guide.headline }}</h1>\n  <p>by: {{ guide.byline }}</p>\n  <p>{{ guide.created | date: 'longDate' }}</p>\n  <hr />\n  <p>{{ guide.text }} </p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/guides/guide/guide.component.html
// module id = ../../../../../src/app/dashboard/guides/guide/guide.component.html
// module chunks = 2